module.exports = __webpack_public_path__ + "static/media/LOGO_white.b8870157.svg";